var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "info_40dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE6B2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C0F3",
    offset: "30.6917671%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCCFFE",
    offset: "76.7919917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 208,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0214\\u66F4\\u65B0-\\u901A\\u77E5\\u6837\\u5F0F",
    transform: "translate(-936.000000, -225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_40dp",
    transform: "translate(936.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333333,11.6666667 L21.6666667,11.6666667 L21.6666667,15 L18.3333333,15 L18.3333333,11.6666667 Z M18.3333333,18.3333333 L21.6666667,18.3333333 L21.6666667,28.3333333 L18.3333333,28.3333333 L18.3333333,18.3333333 Z M20,3.33333333 C10.8,3.33333333 3.33333333,10.8 3.33333333,20 C3.33333333,29.2 10.8,36.6666667 20,36.6666667 C29.2,36.6666667 36.6666667,29.2 36.6666667,20 C36.6666667,10.8 29.2,3.33333333 20,3.33333333 Z M20,33.3333333 C12.65,33.3333333 6.66666667,27.35 6.66666667,20 C6.66666667,12.65 12.65,6.66666667 20,6.66666667 C27.35,6.66666667 33.3333333,12.65 33.3333333,20 C33.3333333,27.35 27.35,33.3333333 20,33.3333333 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyInfo);
export default __webpack_public_path__ + "static/media/notify_info.b6f93ba3bee153b27fe6274673843c50.svg";
export { ForwardRef as ReactComponent };